import get from 'lodash/get';
import { useHistory } from 'react-router';
import QueryString from 'query-string';
import { omitFromQs } from 'common/utils/utils';

const useQueryParam = ({ paramName, shouldOmit = false } = {}) => {
  const history = useHistory();
  const search = QueryString.parse(history.location.search);
  const paramValue = get(search, paramName);

  if (shouldOmit) {
    omitFromQs(paramName);
  }
  return paramValue;
};

export default useQueryParam;
